//
//
//
//
//
//
//
//
//
import Language from './Language.vue';
import Mentions from './Mentions.vue';
export default {
  name: 'MentionsLanguage',
  components: {
    Language,
    Mentions
  },
  props: {
    content: {
      type: Object,

      default() {
        return {};
      }

    }
  }
};